module.exports = __webpack_public_path__ + "img/Image_17.b79905f3.png";